import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Box, Stack, Typography } from "@mui/material";
const YELLOW = "#f5c518";
const RED = "#d32f2f";
const cardSx = (color) => ({
    display: "inline-block",
    width: 10,
    height: 14,
    borderRadius: "2px",
    bgcolor: color,
});
/**
 * Booking glyphs (portrait card shapes — the FotMob/Sofascore lineup idiom).
 * Explicit, never inferred: a sending-off must have its red recorded. A player
 * with both a yellow and a red collapses to the overlapped "second yellow" card.
 * Not color-only — every state carries an aria-label.
 */
const PlayerCards = ({ yellowCards, redCards, }) => {
    const yellows = yellowCards ?? 0;
    const reds = redCards ?? 0;
    if (yellows >= 1 && reds >= 1) {
        return (_jsxs(Box, { component: "span", role: "img", "aria-label": "Yellow and red card, sent off", sx: {
                position: "relative",
                display: "inline-block",
                width: 15,
                height: 18,
            }, children: [_jsx(Box, { component: "span", sx: { ...cardSx(RED), position: "absolute", right: 0, bottom: 0 } }), _jsx(Box, { component: "span", sx: { ...cardSx(YELLOW), position: "absolute", left: 0, top: 0 } })] }));
    }
    if (reds >= 1) {
        return (_jsx(Box, { component: "span", role: "img", "aria-label": "Red card", sx: cardSx(RED) }));
    }
    if (yellows >= 1) {
        const count = Math.min(yellows, 2);
        return (_jsx(Box, { component: "span", role: "img", "aria-label": count === 2 ? "Two yellow cards" : "Yellow card", sx: { display: "inline-flex", gap: "3px" }, children: Array.from({ length: count }).map((_, i) => (_jsx(Box, { component: "span", sx: cardSx(YELLOW) }, i))) }));
    }
    return null;
};
/**
 * Trailing per-player match glyphs on a squad row: a single goal ball + a count
 * (never one-ball-per-goal — a 9-goal game would overflow the row), then the
 * booking cards. Shared by the intra-squad/external and league match squads.
 */
export const PlayerMatchStatGlyphs = ({ goalsScored, yellowCards, redCards, }) => {
    const goals = goalsScored ?? 0;
    return (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", children: [goals > 0 && (_jsxs(Stack, { direction: "row", spacing: 0.25, alignItems: "center", role: "img", "aria-label": goals === 1 ? "1 goal" : `${goals} goals`, children: [_jsx(SportsSoccerIcon, { sx: { fontSize: 16, color: "text.secondary" } }), goals > 1 && (_jsx(Typography, { variant: "caption", color: "text.secondary", sx: { fontVariantNumeric: "tabular-nums" }, children: goals }))] })), _jsx(PlayerCards, { yellowCards: yellowCards, redCards: redCards })] }));
};
